'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _SdkConfig = require('../../../SdkConfig');

var _SdkConfig2 = _interopRequireDefault(_SdkConfig);

var _Validation = require('../elements/Validation');

var _Validation2 = _interopRequireDefault(_Validation);

var _languageHandler = require('../../../languageHandler');

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _Keyboard = require('../../../Keyboard');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createReactClass2.default)({
    displayName: 'CreateRoomDialog',
    propTypes: {
        onFinished: _propTypes2.default.func.isRequired
    },

    getInitialState: function getInitialState() {
        var config = _SdkConfig2.default.get();
        return {
            isPublic: false,
            name: "",
            topic: "",
            alias: "",
            detailsOpen: false,
            noFederate: config.default_federate === false,
            nameIsValid: false
        };
    },
    _roomCreateOptions: function _roomCreateOptions() {
        var createOpts = {};
        createOpts.name = this.state.name;
        if (this.state.isPublic) {
            createOpts.visibility = "public";
            createOpts.preset = "public_chat";
            // to prevent createRoom from enabling guest access
            createOpts['initial_state'] = [];
            var alias = this.state.alias;

            var localPart = alias.substr(1, alias.indexOf(":") - 1);
            createOpts['room_alias_name'] = localPart;
        }
        if (this.state.topic) {
            createOpts.topic = this.state.topic;
        }
        if (this.state.noFederate) {
            createOpts.creation_content = { 'm.federate': false };
        }
        return createOpts;
    },
    componentDidMount: function componentDidMount() {
        this._detailsRef.addEventListener("toggle", this.onDetailsToggled);
        // move focus to first field when showing dialog
        this._nameFieldRef.focus();
    },
    componentWillUnmount: function componentWillUnmount() {
        this._detailsRef.removeEventListener("toggle", this.onDetailsToggled);
    },


    _onKeyDown: function _onKeyDown(event) {
        if (event.key === _Keyboard.Key.ENTER) {
            this.onOk();
            event.preventDefault();
            event.stopPropagation();
        }
    },

    onOk: async function onOk() {
        var _this = this;

        var activeElement = document.activeElement;
        if (activeElement) {
            activeElement.blur();
        }
        await this._nameFieldRef.validate({ allowEmpty: false });
        if (this._aliasFieldRef) {
            await this._aliasFieldRef.validate({ allowEmpty: false });
        }
        // Validation and state updates are async, so we need to wait for them to complete
        // first. Queue a `setState` callback and wait for it to resolve.
        await new _promise2.default(function (resolve) {
            return _this.setState({}, resolve);
        });
        if (this.state.nameIsValid && (!this._aliasFieldRef || this._aliasFieldRef.isValid)) {
            this.props.onFinished(true, this._roomCreateOptions());
        } else {
            var field = void 0;
            if (!this.state.nameIsValid) {
                field = this._nameFieldRef;
            } else if (this._aliasFieldRef && !this._aliasFieldRef.isValid) {
                field = this._aliasFieldRef;
            }
            if (field) {
                field.focus();
                field.validate({ allowEmpty: false, focused: true });
            }
        }
    },

    onCancel: function onCancel() {
        this.props.onFinished(false);
    },

    onNameChange: function onNameChange(ev) {
        this.setState({ name: ev.target.value });
    },
    onTopicChange: function onTopicChange(ev) {
        this.setState({ topic: ev.target.value });
    },
    onPublicChange: function onPublicChange(isPublic) {
        this.setState({ isPublic: isPublic });
    },
    onAliasChange: function onAliasChange(alias) {
        this.setState({ alias: alias });
    },
    onDetailsToggled: function onDetailsToggled(ev) {
        this.setState({ detailsOpen: ev.target.open });
    },
    onNoFederateChange: function onNoFederateChange(noFederate) {
        this.setState({ noFederate: noFederate });
    },
    collectDetailsRef: function collectDetailsRef(ref) {
        this._detailsRef = ref;
    },
    onNameValidate: async function onNameValidate(fieldState) {
        var result = await this._validateRoomName(fieldState);
        this.setState({ nameIsValid: result.valid });
        return result;
    },


    _validateRoomName: (0, _Validation2.default)({
        rules: [{
            key: "required",
            test: async function test(_ref) {
                var value = _ref.value;
                return !!value;
            },
            invalid: function invalid() {
                return (0, _languageHandler._t)("Please enter a name for the room");
            }
        }]
    }),

    render: function render() {
        var _this2 = this;

        var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
        var DialogButtons = _index2.default.getComponent('views.elements.DialogButtons');
        var Field = _index2.default.getComponent('views.elements.Field');
        var LabelledToggleSwitch = _index2.default.getComponent('views.elements.LabelledToggleSwitch');
        var RoomAliasField = _index2.default.getComponent('views.elements.RoomAliasField');

        var privateLabel = void 0;
        var publicLabel = void 0;
        var aliasField = void 0;
        if (this.state.isPublic) {
            publicLabel = _react2.default.createElement(
                'p',
                null,
                (0, _languageHandler._t)("Set a room alias to easily share your room with other people.")
            );
            var domain = _MatrixClientPeg2.default.get().getDomain();
            aliasField = _react2.default.createElement(
                'div',
                { className: 'mx_CreateRoomDialog_aliasContainer' },
                _react2.default.createElement(RoomAliasField, { id: 'alias', ref: function ref(_ref2) {
                        return _this2._aliasFieldRef = _ref2;
                    }, onChange: this.onAliasChange, domain: domain })
            );
        } else {
            privateLabel = _react2.default.createElement(
                'p',
                null,
                (0, _languageHandler._t)("This room is private, and can only be joined by invitation.")
            );
        }

        var title = this.state.isPublic ? (0, _languageHandler._t)('Create a public room') : (0, _languageHandler._t)('Create a private room');
        return _react2.default.createElement(
            BaseDialog,
            { className: 'mx_CreateRoomDialog', onFinished: this.props.onFinished,
                title: title
            },
            _react2.default.createElement(
                'form',
                { onSubmit: this.onOk, onKeyDown: this._onKeyDown },
                _react2.default.createElement(
                    'div',
                    { className: 'mx_Dialog_content' },
                    _react2.default.createElement(Field, { id: 'name', ref: function ref(_ref3) {
                            return _this2._nameFieldRef = _ref3;
                        }, label: (0, _languageHandler._t)('Name'), onChange: this.onNameChange, onValidate: this.onNameValidate, value: this.state.name, className: 'mx_CreateRoomDialog_name' }),
                    _react2.default.createElement(Field, { id: 'topic', label: (0, _languageHandler._t)('Topic (optional)'), onChange: this.onTopicChange, value: this.state.topic }),
                    _react2.default.createElement(LabelledToggleSwitch, { label: (0, _languageHandler._t)("Make this room public"), onChange: this.onPublicChange, value: this.state.isPublic }),
                    privateLabel,
                    publicLabel,
                    aliasField,
                    _react2.default.createElement(
                        'details',
                        { ref: this.collectDetailsRef, className: 'mx_CreateRoomDialog_details' },
                        _react2.default.createElement(
                            'summary',
                            { className: 'mx_CreateRoomDialog_details_summary' },
                            this.state.detailsOpen ? (0, _languageHandler._t)('Hide advanced') : (0, _languageHandler._t)('Show advanced')
                        ),
                        _react2.default.createElement(LabelledToggleSwitch, { label: (0, _languageHandler._t)('Block users on other matrix homeservers from joining this room (This setting cannot be changed later!)'), onChange: this.onNoFederateChange, value: this.state.noFederate })
                    )
                )
            ),
            _react2.default.createElement(DialogButtons, { primaryButton: (0, _languageHandler._t)('Create Room'),
                onPrimaryButtonClick: this.onOk,
                onCancel: this.onCancel })
        );
    }
}); /*
    Copyright 2017 Michael Telatynski <7t3chguy@gmail.com>
    
    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at
    
        http://www.apache.org/licenses/LICENSE-2.0
    
    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
    */

module.exports = exports['default'];
//# sourceMappingURL=CreateRoomDialog.js.map